import { useQuery } from "@tanstack/react-query";
import { AthenaCredentials } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const fetchDataLakeConnectorRegions = async () => AthenaCredentials.listRegions();
const useDataLakeConnectorRegions = () => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: ["data-lake-connector-regions"],
    queryFn: () => defaultOnError(
      fetchDataLakeConnectorRegions(),
      "Loading Data Lake Connector Regions failed with status",
      "Could not load Data Lake Connector Regions."
    ),
    notifyOnChangeProps: ["data", "error"]
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeConnectorRegions;
